import React from "react";
import { Spinner } from "components/common";
import CorrelationSummary from "./CorrelationSummary";
import EventsLicenseStatus from "./EventsLicenseStatus";
import useEventsLicenseStatus from "./hooks/useEventsLicenseStatus";
const CorrelationSummaryContainer = ({ ...otherProps }) => {
  const eventsLicenseStatus = useEventsLicenseStatus();
  if (eventsLicenseStatus.loading) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading Event Correlation information..." });
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(EventsLicenseStatus, { licenseStatus: eventsLicenseStatus }), /* @__PURE__ */ React.createElement(CorrelationSummary, { ...otherProps }));
};
export default CorrelationSummaryContainer;
